import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=0908a107&scoped=true&"
import script from "./VideoForm.vue?vue&type=script&lang=ts&"
export * from "./VideoForm.vue?vue&type=script&lang=ts&"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=0908a107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0908a107",
  null
  
)

export default component.exports